type DurationToWpm = (duration: number) => number;

/**
 * @description Converts a duration in milliseconds per character to words per minute (WPM)
 * 12e3 [(ms·w)/(ch·min)] = 1000 [ms/s] * 60 [s/min] / 5 [ch/w]
 * @param duration
 */
export const durationToWPM: DurationToWpm = (duration) =>
  Boolean(duration) ? 12e3 / duration : 0;
